import { Commit } from 'vuex';

import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { getAccountConfig } from '@accountFederation/config/accountConfig';

interface IdCardVerificationConfig {
    isMultiStepIdVerification: boolean;
}
interface UIStateRoot {
    idCardVerificationConfig: IdCardVerificationConfig;
}

export default {
    namespaced: true,
    state: {
        idCardVerificationConfig: {
            isMultiStepIdVerification: false,
        },
    },
    actions: {
        initializeIdCardVerification({ commit }: { commit: Commit }, isMultiStepIdVerification: boolean) {
            commit('INITIALIZE_ID_CARD_VERIFICATION', isMultiStepIdVerification);
        },
    },
    getters: {
        isMultiStepIdVerification: (state: UIStateRoot) => {
            return state.idCardVerificationConfig.isMultiStepIdVerification;
        },
        idVerificationModalCode: (state: UIStateRoot) => {
            return state.idCardVerificationConfig.isMultiStepIdVerification ? modalCodes.multiStepIdVerification : modalCodes.idCardVerification;
        },
        idVerificationPendingStatusModalCode: (state: UIStateRoot) => {
            return state.idCardVerificationConfig.isMultiStepIdVerification ? modalCodes.idCardVerificationPendingStatus : modalCodes.idCardVerification;
        },
        multiStepIdVerificationGroup: (state: UIStateRoot) => {
            if (getAccountConfig().hasGetIdKyc) {
                return modalCodes.getIdVerification;
            }

            return state.idCardVerificationConfig.isMultiStepIdVerification ? modalCodes.multiStepIdVerification : null;
        },
    },
    mutations: {
        INITIALIZE_ID_CARD_VERIFICATION(state: UIStateRoot, isMultiStepIdVerification: boolean) {
            state.idCardVerificationConfig.isMultiStepIdVerification = isMultiStepIdVerification;
        },
    },
};
